import { MAILTO } from "@/lib/site";

const EMAIL = "ashg.skrg@gmail.com";

export default function Footer() {
  return (
    <footer className="site-footer" data-testid="site-footer">
      <div className="wrap">
        <div className="footer-grid">
          <div className="footer-col" data-testid="footer-brand">
            <div className="footer-brand">Himalayan Actives</div>
            <p className="footer-tagline">Sea buckthorn ingredient solutions for global buyers</p>
          </div>

          <div className="footer-col" data-testid="footer-contact">
            <div className="footer-label">Email</div>
            <a className="footer-link" href={MAILTO} data-testid="footer-email">
              {EMAIL}
            </a>
          </div>

          <div className="footer-col" data-testid="footer-office">
            <div className="footer-label">Office</div>
            <address className="footer-address">
              Khasara No. 121 Min, Lakjung,<br />
              Tirith Nobra, Nubra,<br />
              Leh Ladakh,<br />
              Leh - 194401,<br />
              Jammu &amp; Kashmir, India
            </address>
          </div>
        </div>
        <div className="footer-divider" />
        <div className="footer-bottom">© Himalayan Actives. All rights reserved.</div>
      </div>
    </footer>
  );
}
